
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.55 23.703c.072 0 .108.077.108.23 0 .154-.036.231-.107.231-.764 0-1.36-.013-1.79-.038l-2.434-.039-2.542.039a31.13 31.13 0 01-1.753.038c-.072 0-.108-.077-.108-.23 0-.154.036-.23.108-.23.906 0 1.575-.065 2.004-.193.43-.128.716-.37.86-.73.142-.383.214-.96.214-1.727V3.428c0-.87-.048-1.446-.143-1.728-.072-.282-.275-.46-.609-.538-.334-.076-1.014-.115-2.04-.115H8.98c-1.074 0-1.79.039-2.148.115-.358.077-.585.27-.68.576-.095.282-.143.845-.143 1.69v17.626c0 .768.071 1.344.215 1.728.167.358.453.601.859.73.43.127 1.11.191 2.04.191.048 0 .072.077.072.23 0 .154-.024.231-.072.231-.74 0-1.324-.013-1.754-.038l-2.577-.039-2.434.039c-.43.025-1.026.038-1.79.038-.048 0-.072-.077-.072-.23 0-.154.024-.23.072-.23.907 0 1.575-.065 2.004-.193.454-.128.752-.37.895-.73.167-.383.25-.96.25-1.727V3.735c0-.793-.083-1.408-.25-1.843-.143-.435-.441-.755-.895-.96C2.12.727 1.462.625.604.625.556.625.532.548.532.395c0-.154.024-.23.072-.23.811 0 1.587.012 2.326.037C6.033.254 9.29.28 12.703.28c3.102 0 6.657-.038 10.666-.115h1.182c.071 0 .107.077.107.23 0 .154-.036.23-.107.23-1.241 0-2.076.231-2.506.692-.406.46-.608 1.267-.608 2.42v17.318c0 .768.071 1.344.214 1.728.167.358.466.601.895.73.43.127 1.098.191 2.005.191z","fill":"#000C1F"}}),_c('rect',{attrs:{"x":"29.158","y":"6.664","width":"15","height":"11","rx":"1.5","stroke":"#000C1F","stroke-dasharray":"4 4"}})])
          )
        }
      }
    